//#region src/core/ui/title/data.ts
/** @internal */
const TitleDataAttrs = {
	/** Present when the element is hidden because no title is available. */
	hidden: "data-hidden",
	/** Present while the player controls are visible. */
	visible: "data-visible"
};
//#endregion
export { TitleDataAttrs };

//# sourceMappingURL=data.js.map